import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CButton, CCard, CCol, CFormInput, CFormLabel, CFormTextarea, CRow } from '@coreui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CIcon from '@coreui/icons-react'
import { cilCircle, cilSquare, cilTrash } from '@coreui/icons'
import {
  faAlignLeft,
  faCheckSquare,
  faChevronCircleDown,
  faDotCircle,
  faPlusCircle,
} from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'
import { createMetaData, updateMetaData } from '../../../../Redux/Actions/metaDataAction'
import { isEmpty } from 'src/views/utils/helper'

const options = [
  {
    value: 'dropdown',
    label: (
      <div>
        <FontAwesomeIcon className="mx-1" icon={faChevronCircleDown} size="sm" />
        Dropdown
      </div>
    ),
  },
  {
    value: 'checkboxes',
    label: (
      <div>
        <FontAwesomeIcon className="mx-1" icon={faCheckSquare} size="sm" />
        Checkboxes
      </div>
    ),
  },
  {
    value: 'radio',
    label: (
      <div>
        <FontAwesomeIcon className="mx-1" icon={faDotCircle} size="sm" />
        Multiple choice
      </div>
    ),
  },
  {
    value: 'text',
    label: (
      <div>
        <FontAwesomeIcon className="mx-1" icon={faAlignLeft} size="sm" />
        Text field
      </div>
    ),
  },
]

const AddCustom = ({ setShowAdd, editInfo, setEditInfo, isMarketing }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    handleEditCustom()
  }, [editInfo])

  const ENTITY_OPTIONS = isMarketing
    ? [
        {
          value: 'campaign',
          label: 'Campaign',
        },
        {
          value: 'campaign-audience',
          label: 'Campaign-CampaignAudience',
        },
        {
          value: 'email-template',
          label: 'Email-Template',
        },
      ]
    : [
        {
          value: 'content',
          label: 'Content',
        },
        {
          value: 'artist',
          label: 'Artist',
        },
        {
          value: 'venue',
          label: 'Venue',
        },
      ]

  const [fieldName, setFieldName] = useState('')
  const [editFlag, setEditFlag] = useState(false)
  const [selectedOption, setSelectedOption] = useState({
    value: 'dropdown',
    label: (
      <div>
        <FontAwesomeIcon className="mx-1" icon={faChevronCircleDown} size="sm" />
        Dropdown
      </div>
    ),
  })

  const [selectedEntity, setSelectedEntity] = useState(
    isMarketing
      ? {
          value: 'campaign',
          label: 'Campaign',
        }
      : {
          value: 'content',
          label: 'Content',
        },
  )

  const [dynamicInputList, setDynamicInputList] = useState([{ name: '' }])
  const [rangeSet, setRangeSet] = useState([''])
  const [errorData, setErrorData] = useState({})
  const [dynamicErrorData, setDynamicErrorData] = useState([{ name: '' }])

  let addFormFields = () => {
    setDynamicInputList([...dynamicInputList, { name: '' }])
    setDynamicErrorData([...dynamicErrorData, { name: '' }])
    setRangeSet([...rangeSet, ''])
  }

  let removeFormFields = (i) => {
    let temp = [...dynamicInputList]
    let tempErr = [...dynamicErrorData]
    let tempRange = [...rangeSet]
    temp.splice(i, 1)
    tempErr.splice(i, 1)
    tempRange.splice(i, 1)
    setDynamicInputList(temp)
    setDynamicErrorData(tempErr)
    setRangeSet(tempRange)
  }
  let handleChange = (i, e) => {
    let temp = [...dynamicInputList]
    let tempErr = [...dynamicErrorData]
    let tempRange = [...rangeSet]
    tempErr[i].name = ''
    temp[i].name = e.target.value
    tempRange[i] = e.target.value
    setDynamicErrorData(tempErr)
    setRangeSet(tempRange)
  }
  const displayFields = dynamicInputList.map((ele, index) => {
    return (
      <div key={index}>
        <div className="mt-2 mb-2 d-flex">
          <CCol className="d-flex" xs="4">
            {selectedOption.value === 'dropdown' ? `${index + 1}.` : null}
            {selectedOption.value === 'checkboxes' ? (
              <CIcon icon={cilSquare} size="lg" className="mt-1" />
            ) : null}
            {selectedOption.value === 'radio' ? (
              <CIcon icon={cilCircle} size="lg" className="mt-1" />
            ) : null}
            <CFormInput
              size="sm"
              className="mx-3"
              value={ele.name}
              onChange={(e) => handleChange(index, e)}
            />
          </CCol>
          <CCol className="d-flex py-1" xs="1">
            {index > 0 ? (
              <CIcon
                icon={cilTrash}
                style={{ color: 'red' }}
                size="lg"
                onClick={() => removeFormFields(index)}
              />
            ) : null}
            {index === dynamicInputList.length - 1 ? (
              <FontAwesomeIcon
                className="mx-1"
                icon={faPlusCircle}
                size="lg"
                onClick={addFormFields}
              />
            ) : null}
          </CCol>
        </div>
        <div className="message-text error-message mx-4">
          <p>{dynamicErrorData[index].name}</p>
        </div>
      </div>
    )
  })
  const optionView = () => {
    switch (selectedOption.value) {
      case 'dropdown':
        return (
          <>
            <CFormLabel style={{ fontSize: '1.2rem' }}>Provide dropdown options</CFormLabel>
            {displayFields}
          </>
        )
      case 'checkboxes':
        return (
          <>
            <CFormLabel style={{ fontSize: '1.2rem' }}>Provide checkbox options</CFormLabel>
            {displayFields}
          </>
        )
      case 'radio':
        return (
          <>
            <CFormLabel style={{ fontSize: '1.2rem' }}>
              Provide mulltiple choice radio button options
            </CFormLabel>
            {displayFields}
          </>
        )
      case 'text':
        return (
          <>
            <CFormTextarea
              rows="3"
              className="w-50 "
              placeholder="Text field to be filled up during run time within 150 words."
              disabled
            />
          </>
        )
      default:
        return
    }
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {
      fieldName: '',
    }
    let tempDynamic = dynamicErrorData

    if (fieldName.trim().length === 0) {
      isFormValid = false
      temp.fieldName = 'Name cannot be Empty!'
    }

    if (selectedOption.value !== 'text') {
      for (let index = 0; index < dynamicInputList.length; index++) {
        const element = dynamicInputList[index]

        if (element.name.trim().length === 0) {
          isFormValid = false
          tempDynamic[index].name = 'Option cannot be Empty!'
        }
      }
    }

    setDynamicErrorData([...tempDynamic])
    setErrorData({ ...temp })
    return isFormValid
  }
  const handleSubmit = async () => {
    if (validateInfo()) {
      let data = {
        name: fieldName,
        type: selectedOption.value,
        range_values: rangeSet,
        entity_type: selectedEntity.value,
      }
      console.log(data, 'rangeSet')
      let res = await dispatch(createMetaData('custom', data))
      if (res?.success) {
        dispatch({ type: 'REFRESH_DATA' })
        clearState()
        setShowAdd(false)
      }
    }
  }

  const handleEditCustom = () => {
    if (!isEmpty(editInfo)) {
      setEditFlag(true)
      setFieldName(editInfo.name)
      setRangeSet(editInfo.range_values)
      setSelectedOption(options.find((ele) => ele.value === editInfo.type))
      setSelectedEntity(ENTITY_OPTIONS.find((ele) => ele.value === editInfo.entity_type))
      let temp = []
      let tempErr = []

      for (let index = 0; index < editInfo.range_values.length; index++) {
        const element = editInfo.range_values[index]

        tempErr.push({
          name: '',
        })
        temp.push({
          name: element,
        })
      }
      setDynamicInputList(temp)
      setDynamicErrorData(tempErr)
    }
  }
  const handleUpdate = async () => {
    if (validateInfo()) {
      let data = {
        name: fieldName,
        type: selectedOption.value,
        range_values: rangeSet,
        entity_type: selectedEntity.value,
      }
      let res = await dispatch(updateMetaData('custom', editInfo._id, data))
      if (res?.success) {
        dispatch({ type: 'REFRESH_DATA' })
        clearState()
        setShowAdd(false)
      }
    }
  }
  const handleBack = () => {
    clearState()
    setShowAdd(false)
  }

  const clearState = () => {
    setFieldName('')
    setSelectedOption({
      value: 'Dropdown',
      label: (
        <div>
          <FontAwesomeIcon className="mx-1" icon={faChevronCircleDown} size="sm" />
          Dropdown
        </div>
      ),
    })
    setDynamicInputList([{ name: '' }])
    setDynamicErrorData([{ name: '' }])
    setRangeSet([''])
    setErrorData([{}])
    setEditFlag(false)
    setEditInfo({})
  }

  return (
    <div>
      <CRow className="mt-4">
        <CCard style={{ minHeight: '20rem' }}>
          <div className="mt-4 mx-3">
            <CFormLabel className="h5 font-weight-bold">
              {editFlag ? `Edit` : `Add a new `} Metadata Field.
            </CFormLabel>
            <div style={{ maxHeight: '35rem' }} className="mt-4 scrollbar-class">
              <div>
                <p className="h5 font-weight-bold">
                  <em>
                    Step 1
                    <hr />
                  </em>
                </p>
                <CRow>
                  <CCol>
                    <CFormLabel style={{ fontSize: '1.2rem' }}>Metadata Field Name</CFormLabel>
                    <CFormInput
                      size="sm"
                      className="w-50"
                      value={fieldName}
                      onChange={(e) => {
                        setFieldName(e.target.value)
                        setErrorData({ ...errorData, fieldName: '' })
                      }}
                    />
                    <div className="message-text error-message">
                      <p>{errorData.fieldName}</p>
                    </div>
                  </CCol>
                  <CCol>
                    <CFormLabel style={{ fontSize: '1.2rem' }}>Entity Type</CFormLabel>
                    <Select
                      value={selectedEntity}
                      onChange={setSelectedEntity}
                      options={ENTITY_OPTIONS}
                      className="w-50"
                      isSearchable={false}
                    />
                    <div className="message-text error-message">
                      <p>{errorData.fieldName}</p>
                    </div>
                  </CCol>
                </CRow>
              </div>
              <div className="mt-4">
                <p className="h5 font-weight-bold">
                  <em>
                    Step 2
                    <hr />
                  </em>
                </p>
                <CFormLabel style={{ fontSize: '1.2rem' }} className="w-100">
                  Select field type
                </CFormLabel>
                <Select
                  defaultValue={selectedOption}
                  value={selectedOption}
                  onChange={setSelectedOption}
                  options={options}
                  className="w-50"
                  isSearchable={false}
                />
              </div>
              <div className="mt-4">
                <p className="h5 font-weight-bold">
                  <em>
                    Step 3
                    <hr />
                  </em>
                </p>
                {optionView()}
              </div>
            </div>
            <div className="d-flex flex-row-reverse mb-3">
              <CButton
                color="info"
                className="text-white mx-5"
                onClick={editFlag ? handleUpdate : handleSubmit}
              >
                Save
              </CButton>
              <CButton color="info" className="text-white mx-4" onClick={handleBack}>
                Back
              </CButton>
            </div>
          </div>
        </CCard>
      </CRow>
    </div>
  )
}

export default AddCustom
